import React, { useState } from "react";

const getTipoPlato = (plato) => plato?.tipoplato?.nombre || plato?.plato?.tipoplato?.nombre || plato?.tipo || 'Sin clasificar';

const ModalEditarPlato = ({ open, onClose, platosDisponibles, pedido, onSelect }) => {
  const [itemSeleccionado, setItemSeleccionado] = useState(null);

  // Inicializar con el plato o bebida actual del pedido
  React.useEffect(() => {
    if (open) {
      if (pedido?.id_plato) {
        const platoActual = platosDisponibles.find(p => p.id_plato === pedido.id_plato && !p.bebida_id);
        setItemSeleccionado(platoActual || null);
      } else if (pedido?.bebida_id) {
        const bebidaActual = platosDisponibles.find(p => p.bebida_id === pedido.bebida_id);
        setItemSeleccionado(bebidaActual || null);
      }
    } else {
      setItemSeleccionado(null);
    }
  }, [open, pedido, platosDisponibles]);

  if (!open) return null;

  // Separar platos de bebidas
  const platos = platosDisponibles.filter(p => !p.bebida_id);
  const bebidas = platosDisponibles.filter(p => p.bebida_id);

  // Agrupar platos por tipo
  const grupos = {};
  platos.forEach(plato => {
    const tipoKey = getTipoPlato(plato);
    if (!grupos[tipoKey]) grupos[tipoKey] = [];
    grupos[tipoKey].push(plato);
  });

  const gruposConPlatos = Object.fromEntries(
    Object.entries(grupos).filter(([tipo, platosGrupo]) => platosGrupo.length > 0)
  );

  console.log('ModalEditarPlato: pedido actual =', pedido);
  console.log('ModalEditarPlato: itemSeleccionado =', itemSeleccionado);
  console.log('ModalEditarPlato: platos =', platos.length, ', bebidas =', bebidas.length);

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 transition-opacity duration-300 bg-black bg-opacity-50 animate-fadein">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-2xl transform transition-all duration-300 animate-fadeinModal max-h-96 overflow-y-auto">
        <h3 className="text-2xl font-bold mb-6 text-blue-800 tracking-tight">Editar para el día <span className='text-blue-700'>{pedido?.fecha}</span></h3>

        {/* Contenedor de dos columnas */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          {/* Columna izquierda: Platos */}
          <div className="space-y-4">
            <h4 className="text-lg font-bold text-orange-700 bg-orange-50 px-4 py-2 rounded-lg border-l-4 border-orange-400">
              🍽️ Platos
            </h4>
            {platos.length === 0 ? (
              <p className="text-gray-500 italic">No hay platos disponibles</p>
            ) : (
              <form className="space-y-3">
                {Object.entries(gruposConPlatos).map(([tipo, platosGrupo]) => (
                  <div key={tipo}>
                    <div className="text-sm font-semibold text-gray-600 mb-2 px-2">{tipo}</div>
                    <div className="space-y-2">
                      {platosGrupo.map(plato => (
                        <label
                          key={plato.id_plato || `plato-${plato.nombre}`}
                          className={`flex items-center gap-3 p-2 rounded-lg border transition cursor-pointer text-sm ${itemSeleccionado?.id_plato === plato.id_plato
                              ? 'bg-orange-100 border-orange-400 shadow'
                              : 'bg-slate-50 border-slate-200 hover:bg-orange-50 hover:border-orange-300'
                            }`}
                        >
                          <input
                            type="radio"
                            name="item-seleccion"
                            className="w-4 h-4 accent-orange-600"
                            checked={itemSeleccionado?.id_plato === plato.id_plato}
                            onChange={() => setItemSeleccionado(plato)}
                          />
                          <span className="text-slate-800 font-medium">{plato.nombre}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                ))}
              </form>
            )}
          </div>

          {/* Columna derecha: Bebidas */}
          <div className="space-y-4">
            <h4 className="text-lg font-bold text-blue-700 bg-blue-50 px-4 py-2 rounded-lg border-l-4 border-blue-400">
              🥤 Bebidas
            </h4>
            {bebidas.length === 0 ? (
              <p className="text-gray-500 italic">No hay bebidas disponibles</p>
            ) : (
              <form className="space-y-2">
                {bebidas.map(bebida => (
                  <label
                    key={bebida.bebida_id || `bebida-${bebida.nombre}`}
                    className={`flex items-center gap-3 p-2 rounded-lg border transition cursor-pointer text-sm ${itemSeleccionado?.bebida_id === bebida.bebida_id
                        ? 'bg-blue-100 border-blue-400 shadow'
                        : 'bg-slate-50 border-slate-200 hover:bg-blue-50 hover:border-blue-300'
                      }`}
                  >
                    <input
                      type="radio"
                      name="item-seleccion"
                      className="w-4 h-4 accent-blue-600"
                      checked={itemSeleccionado?.bebida_id === bebida.bebida_id}
                      onChange={() => setItemSeleccionado(bebida)}
                    />
                    <span className="text-slate-800 font-medium">
                      {bebida.nombre || `${bebida.marca || ''} - ${bebida.sabor || ''}`.trim()}
                    </span>
                  </label>
                ))}
              </form>
            )}
          </div>
        </div>

        <div className="flex justify-end gap-4 mt-6 border-t pt-4">
          <button className="px-5 py-2 rounded-lg bg-gray-200 text-slate-800 font-semibold shadow hover:bg-gray-300 transition" onClick={onClose}>Cancelar</button>
          <button
            className={`px-5 py-2 rounded-lg bg-blue-600 text-white font-bold shadow-lg transition ${!itemSeleccionado ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-700'}`}
            disabled={!itemSeleccionado}
            onClick={() => {
              if (itemSeleccionado) onSelect(itemSeleccionado);
            }}
          >Guardar cambios</button>
        </div>
      </div>
      <style>{`
        @keyframes fadein { from { opacity: 0; } to { opacity: 1; } }
        .animate-fadein { animation: fadein 0.3s; }
        @keyframes fadeinModal { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        .animate-fadeinModal { animation: fadeinModal 0.3s; }
      `}</style>
    </div>
  );
};

export default ModalEditarPlato;
